import { call, put, takeLatest, select } from "redux-saga/effects";
import { FILE, MESSAGES } from "../actions";
import generateAction from "../../utils/action-helpers";
import {
  getFiles,
  uploadFile,
  downloadLearningFile,
  uploadLearningFile,
  uploadLearningFileData
} from "../../api/files";
import redirectToLogin from "../../utils/redirect-to-login";
import { messageState } from "../../utils/messajes";
import moment from "moment";

function* fetch() {
  try {
    yield generateAction(FILE.LOADING);
    const response = yield call(getFiles);
    const mappedList = response.data.map(x => {
      const updatedDate = new Date(x.updatedAt ? x.updatedAt : x.createdAt);
      const parsedDate = updatedDate ? moment(updatedDate).format("DD/MM/YYYY") : " - - ";
      return {
        ...x,
        updateAt: parsedDate,
        disabled: x.state === "uploading",
        error: x.state === "error"
      };
    });
    yield put(generateAction(FILE.FETCH_SUCCESS, mappedList));
    yield put(generateAction(MESSAGES.FILE_STATUS, messageState.SUCCESS));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(MESSAGES.FILE_STATUS, messageState.ERROR));
    yield put(generateAction(FILE.FETCH_ERROR));
  }
}

function* fetchKnow() {
  try {
    const file = yield select(state => state.files.files.find(x => x.type === "CLIENT_NAMES"));
    if (file) {
      const { data } = yield call(downloadLearningFile);
      window.open(data);
      yield put(generateAction(FILE.FETCH_KNOW_SUCCESS, null));
      yield put(generateAction(MESSAGES.UPLOAD_STATUS, messageState.SUCCESS));
    }
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(MESSAGES.UPLOAD_STATUS, messageState.ERROR));
    yield put(generateAction(FILE.UPLOAD_ERROR));
  }
}

function* upload(action) {
  try {
    yield generateAction(FILE.LOADING);
    const { payload } = action;
    const { data } = yield call(uploadFile, payload);
    yield put(generateAction(FILE.UPLOAD_SUCCESS, data));
    yield put(generateAction(MESSAGES.UPLOAD_STATUS, messageState.SUCCESS));
    yield put(generateAction(FILE.FETCH));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(MESSAGES.UPLOAD_STATUS, messageState.ERROR));
    yield put(generateAction(FILE.UPLOAD_ERROR));
  }
}

function* uploadLearningFileDataSaga() {
  try {
    const { data } = yield call(uploadLearningFileData);
    yield put(generateAction(FILE.UPLOAD_LEARNING_FILE_DATA_SUCCESS, data));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(FILE.UPLOAD_LEARNING_FILE_DATA_ERROR));
  }
}

function* uploadLearningFileSaga(action) {
  try {
    const { payload } = action;
    yield call(uploadLearningFile, payload);
    yield put(generateAction(FILE.UPLOAD_LEARNING_FILE_SUCCESS));
    yield put(generateAction(FILE.FETCH));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(FILE.UPLOAD_LEARNING_FILE_ERROR));
  }
}

export default function* filesSagas() {
  yield takeLatest(FILE.FETCH, fetch);
  yield takeLatest(FILE.UPLOAD, upload);
  yield takeLatest(FILE.UPLOAD_LEARNING_FILE_DATA, uploadLearningFileDataSaga);
  yield takeLatest(FILE.UPLOAD_LEARNING_FILE, uploadLearningFileSaga);
  yield takeLatest(FILE.FETCH_KNOW, fetchKnow);
}
